/**
 * Shared "schema.table" string helpers for Pipeline Engineer job editors.
 *
 * A job's ``target_table`` (and a driver ``source_tables[].table``) is
 * persisted as a single string, optionally schema-qualified with a dot
 * (e.g. "Sales.SpecialOffer"). These helpers split/join that convention
 * consistently across the Target tab's schema picker (TargetTablePanel)
 * and the Columns tab's Auto-Map Columns introspection (ColumnMappingGrid).
 */

/** Split "schema.table" into its parts. No dot means no schema (schema=""). */
export function splitSchemaTable(full: string): {
  schema: string;
  table: string;
} {
  const idx = full.indexOf(".");
  if (idx === -1) return { schema: "", table: full };
  return { schema: full.slice(0, idx), table: full.slice(idx + 1) };
}

/** Join schema + table back into the "schema.table" string saved on the job. */
export function joinSchemaTable(schema: string, table: string): string {
  const trimmedSchema = schema.trim();
  const trimmedTable = table.trim();
  return trimmedSchema ? `${trimmedSchema}.${trimmedTable}` : trimmedTable;
}
